export default "ui-textcounter{display:block;width:100%;max-width:var(--ui-field-width)}@media screen and (max-width:767px){ui-textcounter{max-width:none}}\n";